<a mat-icon-button (click)="openInfoDialog()" class="info-icon"><mat-icon>info</mat-icon></a>

